(function(){
  angular.module('tf.retailer.Util')
      .directive('datePickerWithPresetRange', DatePickerWithPresetRange)
      .controller('DatePickerWithPresetRangeCtrl', DatePickerWithPresetRangeCtrl)
      .factory('DatePickerRange', DatePickerRange);

  function DatePickerWithPresetRange(){
    return{
      restrict: 'E',
      scope : {
        dateRange: "=",
        onApply: '&',
        keepState: '@'
      },
      templateUrl : 'Util/DatePickerWithPresetRange/DatePickerWithPresetRange.tmpl.html',
      controller : 'DatePickerWithPresetRangeCtrl as vm',
      bindToController: true
    }
  }


  function DatePickerWithPresetRangeCtrl($state, $stateParams, DateUtil, MIN_DATE,Filters, DatePickerRange,
                                         AnalyticsHelper) {
    var vm = this;

    var filters = Filters.getFilter();
    vm.minStartDate = DateUtil.shortMonthDate(MIN_DATE);
    vm.maxDefaultEndDate = DateUtil.shortMonthDate(filters.maxAllowedDate);
    vm.timezone = filters.timezone;
    vm.open = false;

    init();

    vm.presetRanges = DatePickerRange.presetRanges();

    vm.setDateRange = function (dateRange) {
      vm.dateRange.startDate = DateUtil.shortMonthDate(dateRange.dateStart());
      vm.dateRange.endDate = DateUtil.shortMonthDate(dateRange.dateEnd());
    };

    vm.onToggle = function(open){
      if(!open && (_.eq(vm.dateRange.startDate, $stateParams.startDate)
          && _.eq(vm.dateRange.endDate, $stateParams.endDate))){
        init();
      }
    };

    vm.updateDateRange = function(){
      vm.titleDateRange = angular.copy(vm.dateRange);
      AnalyticsHelper.sendDateRangeChangeEvent(vm.dateRange, vm.presetRanges);
      if(!vm.keepState) {
        $state.go('.', {
          startDate: DateUtil.formatToYearMonthDay(vm.dateRange.startDate),
          endDate: DateUtil.formatToYearMonthDay(vm.dateRange.endDate), detailLevel: null
        });  // Unset detailLevel Case 76712
      } else {
        vm.onApply();
        vm.open = false;
      }
    };

    function init() {
      vm.dateRange.startDate = DateUtil.shortMonthDate(vm.dateRange.startDate);
      vm.dateRange.endDate = DateUtil.shortMonthDate(vm.dateRange.endDate);
      vm.titleDateRange = angular.copy(vm.dateRange);   // Need to keep a deep copy to display title date range & update on only apply()
    }
  }

  function DatePickerRange(Filters, MIN_DATE) {

    function createDateRanges() {
      var minStartDate = moment(MIN_DATE);

      var presetRanges = function () {
        var filters = Filters.getFilter();
        return [
          {
            text: 'Month to Date',
            dateStart: function() { return moment.max(minStartDate, moment(filters.maxAllowedDate).startOf('month')) },
            dateEnd: function() { return moment(filters.maxAllowedDate) }
          },{
            text: 'Year to Date',
            dateStart: function() { return moment.max(minStartDate, moment(filters.maxAllowedDate).startOf('year')) },
            dateEnd: function() { return moment(filters.maxAllowedDate) }
          },{
            text: 'Last Week',
            dateStart: function() { return moment.max(minStartDate,
                moment(filters.maxAllowedDate).subtract(7, 'days').isoWeekday(0)) },
            dateEnd: function() { return moment(filters.maxAllowedDate).subtract(7, 'days').isoWeekday(6) }
          }, {
            text: 'Last Month',
            dateStart: function() { return moment.max(minStartDate,
                moment(filters.maxAllowedDate).subtract(1, 'month').startOf('month')) },
            dateEnd: function() { return moment(filters.maxAllowedDate).subtract(1, 'month').endOf('month') }
          }, {
            text: 'Last Year',
            dateStart: function() { return moment.max(minStartDate, moment(filters.maxAllowedDate).subtract(1, 'year')) },
            dateEnd: function() { return moment(filters.maxAllowedDate) }
          }
        ];
      };

      return {
        presetRanges: presetRanges,
        getRange : function (rangeName) {
          return _.find(presetRanges, { text: rangeName });
        }
      }
    }

    return createDateRanges();
  }

})();